import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import SubscriptionOverlay from '../common/SubscriptionOverlay';
import ImportProgressToast from '../common/ImportProgressToast';
import { useAuth } from '../../contexts/AuthContext';
import { useAccount } from '../../contexts/AccountContext';

const Layout = () => {
  const { user, logout } = useAuth();
  const { company_name, currentPlan, subscriptionData } = useAccount();

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar user={user} logout={logout} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: 'white',
        }}
      >
        <Header user={user} logout={logout} company_name={company_name} subscriptionData={subscriptionData} />

        {/* ✅ Global import progress toast (authenticated-only, persistent) */}
        <ImportProgressToast />

        <Box
          id="main-content"
          sx={{
            flexGrow: 1,
            position: 'relative',
            overflow: 'auto',
            minHeight: 0,
            display: 'block',
          }}
        >
          <Box sx={{ width: '100%', minHeight: 0, display: 'block' }}>
            <Outlet />
          </Box>

          {/* Subscription Overlay - only covers content area */}
          <SubscriptionOverlay currentPlan={currentPlan} company_name={company_name} />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
